import { Component, input, output } from '@angular/core';
import { MenuDropdownButtonComponent } from '@sandbox-platform/shared-ui';
import { ReferralDropdownData } from '../desktop-menu.config';
import { NavDropdownComponent } from './nav-dropdown.component';

@Component({
  standalone: true,
  imports: [NavDropdownComponent, MenuDropdownButtonComponent],
  selector: 'lib-referrals-dropdown',
  template: `
    <lib-nav-dropdown
      label="Referrals"
      [isOpen]="isOpen()"
      (toggleClicked)="toggleClicked.emit()"
    >
      @if (items().referrals.length) {
      <div class="py-2 border-b border-gray-700">
        <div
          class="px-4 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider"
        >
          Referrals
        </div>
        @for (item of items().referrals; track item.routerLink) {
        <lib-menu-dropdown-button
          [item]="item"
          (onItemClick)="navigate.emit($event)"
        />
        }
      </div>
      } @if (items().settings.length) {
      <div class="py-2">
        <div
          class="px-4 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider"
        >
          Settings
        </div>
        @for (item of items().settings; track item.routerLink) {
        <lib-menu-dropdown-button
          [item]="item"
          (onItemClick)="navigate.emit($event)"
        />
        }
      </div>
      }
    </lib-nav-dropdown>
  `,
})
export class ReferralsDropdownComponent {
  items = input.required<ReferralDropdownData>();
  isOpen = input.required<boolean>();

  toggleClicked = output<void>();
  navigate = output<string>();
}
